var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"event-item",class:_vm.cssClasses,on:{"click":function($event){_vm.$emit('click', _vm.event, $event)}}},[(_vm.showTitle)?_vm._t("default",[_vm._v("\n    Def: "+_vm._s(_vm.event.title)+"\n  ")],{event:_vm.event}):_vm._e()],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49d36595","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components-base/components-custom/vue-full-calendar/components/event-card.vue
// module id = null
// module chunks = 